import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen overflow-x-hidden overflow-y-scroll" }
const _hoisted_2 = { class: "pt-20" }


export default /*@__PURE__*/_defineComponent({
  __name: 'default',
  setup(__props) {

// import { useMarketingScripts } from '~/composables/useMarketingScripts'

useMarketingScripts();

const isOpen = ref(false);
const handleSidebar = (bool: boolean) => {
  isOpen.value = bool;
};

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_NuxtPage = _resolveComponent("NuxtPage")!
  const _component_USeparator = _resolveComponent("USeparator")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopHeader, { "onSidebar:isOpen": handleSidebar }),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_NuxtPage)
    ]),
    _createVNode(_component_USeparator, {
      avatar: {
        src: '/images/logo_light.svg',
        alt: 'FamilyAxis',
      },
      class: "h-px"
    }),
    _createVNode(_component_MainFooter)
  ]))
}
}

})